
import makerjs from "makerjs";
function B20(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    B = Param[0].param,L = Param[1].param,T = Param[2].param,R = Param[3].param, 
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       b = B * 1 * myZoom,
       l = L * 1 * myZoom,
       t = T * 1 * myZoom,
        r = R * 1 * myZoom,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       
       x0 = 0, x1 = b-t, x2 =b ,x3 =b , y0 = 0, y1 = l,y2 = r, y3 =0,glassH =r, glassW = b,h=r,w=b;

   if (b !== 0) {
       var TxtB ="B="+ B;
   }  if (l !== 0) {
    var TxtL = "L="+L;
  }  if (r !== 0) {
    var TxtR = "R="+R;
  }  if (t !== 0) {
    var TxtT = "T="+T;
  } 



   var drawAbnormalShapeB20 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([x0, y0], [x1, y1]),
        "TopLine":new makerjs.paths.Line([x1,y1], [x2,y2]), 
        "RightLine":new makerjs.paths.Line([x2,y2], [x3,y3]), 
        "BottomLine": new makerjs.paths.Line([x3,y3], [x0, y0]),
       }
   };
   var drawAbnormalShapeB20MarkL = {
       paths: {
        "RightLine": new makerjs.paths.Line([x1- markShift, y0], [x1- markShift, y1]),
        "RightShortUpline": new makerjs.paths.Line([x1, y1], [x1- 2 * markShift, y1]),
        "RightShortDnline": new makerjs.paths.Line([x1, y0], [x1- 2 * markShift, y0]),
       }
   };
   var drawAbnormalShapeB20MarkR = {
       paths: {
        "RightLine": new makerjs.paths.Line([x3+ markShift, y3], [x3+ markShift, y2]),
        "RightShortUpline": new makerjs.paths.Line([x3, y2], [x3+ 2 * markShift, y2]),
        "RightShortDnline": new makerjs.paths.Line([x3, y3], [x3+ 2 * markShift, y3]),
       }
   };
   var drawAbnormalShapeB20MarkB = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x0, y0- markShift], [x3, y3- markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x0, y0], [x0, y0 - 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x3, y3], [x3, y3 - 2 * markShift]),
       }
  
   };
   var drawAbnormalShapeB20MarkT = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x1, y2+ markShift], [x2, y2+ markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x1, y2], [x1, y2 + 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x2, y2], [x2, y2 + 2 * markShift]),
       }
  
   };
   makerjs.model.addCaption(drawAbnormalShapeB20MarkB, TxtB, [x0, y0 - 2 * markShift], [x3, y3 - 2 * markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB20MarkT, TxtT, [x1, y2+ 2*markShift], [x2, y2+ 2*markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB20MarkL, TxtL, [x1-2*markShift, y0], [x1-2*markShift, y1]);//宽度文字
   makerjs.model.addCaption(drawAbnormalShapeB20MarkR, TxtR, [x3+ 3*markShift, y3], [x3+ 3*markShift, y2]);//长度文字
   
  plate={
    models: {
      drawAbnormalShapeB20: drawAbnormalShapeB20,
      }
    };
    markers={
      models: {
        drawAbnormalShapeB20: drawAbnormalShapeB20,
        drawAbnormalShapeB20MarkL: drawAbnormalShapeB20MarkL,
        drawAbnormalShapeB20MarkT: drawAbnormalShapeB20MarkT,
        drawAbnormalShapeB20MarkR: drawAbnormalShapeB20MarkR,
        drawAbnormalShapeB20MarkB:drawAbnormalShapeB20MarkB,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default B20;